.fp-breadcrumb(data-test='breadcrumb')
  template(v-for='(segment, index) in breadcrumbSegments' :key='index')
    router-link.fp-link.-secondary(v-if='!isCurrentSegment(index)' :to='segment.route' :data-test='`segment-${index}`') {{ segment.label }}
    .fp-breadcrumb--separator(v-if='!isCurrentSegment(index)') >
    span.fp-text.-color-shade-900.-text-semi-bold(v-if='isCurrentSegment(index)' data-test='current-segment') {{ segment.label }}
